import Input, { FinalFormInputProps } from 'components/final-form/Input';
import React from 'react';

// Input that allows only uppercase letters, digits and underscore.
// Lowercase letters are automatically converted to uppercase.
// Space and dash are converted to underscore.
export const CodeInput = (props: FinalFormInputProps) => {
  return <Input
      {...props}
      maxLength={props.maxLength || 64}
      onChangeDecorator={codeOnChangeDecorator}
  />;
}

export const CamelCaseCodeInput = (props: FinalFormInputProps) => {
  return <Input
      {...props}
      maxLength={props.maxLength || 96}
      onChangeDecorator={camelCaseCodeOnChangeDecorator}
  />;
}

const codeOnChangeDecorator = (inputElement: HTMLInputElement, value: string) => {

  let newValue = value;

  // Allow only uppercase letter, digit, or underscore.
  const p = /[^0-9A-Z_]/g;
  if (value && value.match(p)) {
    // Remove any non-allowed character in the value
    // Lowercase letters are automatically converted to uppercase.
    // Space and dash are converted to underscore.

    const selStart = inputElement.selectionStart;

    const mutate = (val: string) => {
      return val.toUpperCase()
          .replace(" ", "_")
          .replace("-", "_")
          .replace(p, "");
    }

    // newSelection = [selectionStart, selectionEnd]
    let newSelection: number[] | undefined = undefined;
    if (selStart && selStart > 0 && selStart < value.length) {
      const v1 = mutate(value.substring(0, selStart));
      const v2 = mutate(value.substring(selStart));
      newValue = v1 + v2;

      newSelection = [v1.length, v1.length];
    } else {
      newValue = mutate(value);
    }

    if (newValue !== value) {
      inputElement.value = newValue;

      if (newSelection) {
        inputElement.selectionStart = newSelection[0];
        inputElement.selectionEnd = newSelection[1];
      }
    }
  }
};


const camelCaseCodeOnChangeDecorator = (inputElement: HTMLInputElement, value: string) => {

  let newValue = value;

  // Allow only uppercase letter, digit, or underscore.
  const p = /[^0-9a-zA-Z_]/g;
  if (value && value.match(p)) {
    // Remove any non-allowed character in the value
    // Lowercase letters are automatically converted to uppercase.
    // Space and dash are converted to underscore.

    const selStart = inputElement.selectionStart;

    const mutate = (val: string) => {
      return val
          .replace(" ", "_")
          .replace("-", "_")
          .replace(p, "");
    }

    // newSelection = [selectionStart, selectionEnd]
    let newSelection: number[] | undefined = undefined;
    if (selStart && selStart > 0 && selStart < value.length) {
      const v1 = mutate(value.substring(0, selStart));
      const v2 = mutate(value.substring(selStart));
      newValue = v1 + v2;

      newSelection = [v1.length, v1.length];
    } else {
      newValue = mutate(value);
    }

    if (newValue !== value) {
      inputElement.value = newValue;

      if (newSelection) {
        inputElement.selectionStart = newSelection[0];
        inputElement.selectionEnd = newSelection[1];
      }
    }
  }
};
